// extracted by mini-css-extract-plugin
export var emailBlockLink = "_kk-0";